// Use the actual brand logo from public folder
export const BRAND_LOGO_DATA_URL = "/footer-logo-coffee-bean-tea-leaf.avif";
